import project from "@nextories/vue-tasks/src/i18n/langs/fr/project";
import crmFields from "@nextories/vue-tasks/src/i18n/langs/fr/crmFields";

const idDgts = crmFields.id_dgts;

export default {
  ...project,
  tabs: {
    ...project.tabs,
    estimate: "Estimation",
    steps: "Formulaire",
  },
  est_volume: {
    ...idDgts.est_volume,
    value: "{value} m³",
  },
  est_formule: {
    ...idDgts.est_formule,
  },
  phone: {
    mobile: 'Mobile : <span class="phone">{num}</span>',
    home: 'Domicile : <span class="phone">{num}</span>',
  },
  tasks: "Tâches",
  action: {
    skip: "Le formulaire est invalide, voulez-vous passer le projet ?",
  },
  notUpdated: "Le projet n'est pas à jour",
  subtitle: {
    ...project.subtitle,
    estimate: "Estimation du déménagement",
  },
};
